import React from 'react'
import DropDown from '../dropdown';
import PropTypes from "prop-types";
import {GetWings} from '../../../api/services/organization';

const WingDropDown = ({HotelID, ...rest}) => {
    return <DropDown search api={GetWings} spec={{HotelID: HotelID}} textField="Name" valueField="Id" {...rest} />
}

WingDropDown.propTypes = {
    HotelID:PropTypes.any
}
export default WingDropDown